import React from 'react';
import Link, { LinkProps } from 'housecall-ui/dist/DesignSystem/Navigation/Link/Link';

type Props = {
  helpArticlePath?: string,
  variant?: LinkProps['variant'],
  underline?: LinkProps['underline'],
}

export const HelpArticleLink: React.FC<Props> = ({ helpArticlePath = '', ...otherProps }) => {
  const HELP_ARTICLE_BASE_URL = 'https://help.housecallpro.com/';

  return (
    <Link {...otherProps} href={`${HELP_ARTICLE_BASE_URL}${helpArticlePath}`} target="_blank" rel="noopener noreferrer" />
  );
};

export default HelpArticleLink;
